import React, { KeyboardEvent } from 'react'

import { ColorSwatch, SelectMark } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../../../app/_providers/TranslationProvider.client'
import { CollectionItemFilterOutput } from '../../../../../../../../types/graphql/collection-view'
import { useCollectionFiltersContext } from '../../containers/CollectionFiltersContext'

import { AppliedLabel, AppliedLabelWrap, Body, ClearAll, CloseWrap, LabelText } from './styles'

interface IProps {
  clearAllFilters: () => void
  filters: CollectionItemFilterOutput | null | undefined
  selectedFilters: Record<string, string[]>
  toggleSelectedFilter: (key: string, value: string) => void
}

export const AppliedFilterLabels: React.FC<IProps> = ({
  clearAllFilters,
  filters,
  selectedFilters,
  toggleSelectedFilter,
}) => {
  const { colors } = useCollectionFiltersContext()
  const {
    collections: {
      filtering: { desktopFilterBar: desktopFilterBarCopy },
    },
  } = useTranslation()

  const handleKeyDownClearAll = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      clearAllFilters()
    }
  }

  const handleKeyDownSelectedFilters = (filter: string, value: string, e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      toggleSelectedFilter(filter, value)
    }
  }

  return (
    <Body>
      <AppliedLabelWrap>
        {Object.keys(selectedFilters).length > 0 && (
          <ClearAll
            role='button'
            tabIndex={0}
            onClick={clearAllFilters}
            onKeyDown={e => handleKeyDownClearAll(e)}
          >
            {desktopFilterBarCopy.clearAllFiltersCta}
          </ClearAll>
        )}
        {Object.keys(selectedFilters).map((filterKey, index) => (
          <React.Fragment key={`${filterKey}-${index}`}>
            {selectedFilters[filterKey]?.map(filterValueKey => {
              const color = colors[filterValueKey]
              return (
                <AppliedLabel
                  key={`${filterKey}-${filterValueKey}`}
                  tabIndex={0}
                  role='button'
                  onClick={() => {
                    toggleSelectedFilter(filterKey, filterValueKey)
                  }}
                  onKeyDown={(e: KeyboardEvent) => {
                    handleKeyDownSelectedFilters(filterKey, filterValueKey, e)
                  }}
                >
                  {color && color.hexCodes && (
                    <ColorSwatch
                      colorId={filterValueKey}
                      hexCodes={color.hexCodes}
                      hover={false}
                      selected={false}
                      swatchUrl={color.swatchImage?.url ?? undefined}
                    />
                  )}
                  <LabelText>
                    {filters
                      ?.find(filter => filter.name === filterKey)
                      ?.values.find(filterValue => filterValue.value === filterValueKey)
                      ?.displayValue ?? filterValueKey}
                  </LabelText>
                  <CloseWrap>
                    <SelectMark />
                  </CloseWrap>
                </AppliedLabel>
              )
            })}
          </React.Fragment>
        ))}
      </AppliedLabelWrap>
    </Body>
  )
}
